import type { ApiError, JobSubmitResponse, JobStatusResponse, ScoreHistoryPoint } from "./types";
import { API_ENDPOINTS } from "./constants/api";

export async function getVapidPublicKey(): Promise<string | null> {
  try {
    const res = await fetch(API_ENDPOINTS.vapidPublicKey);
    if (!res.ok) return null;
    const data = await res.json();
    return data.publicKey ?? null;
  } catch {
    return null;
  }
}

export async function subscribePush(
  subscription: PushSubscriptionJSON,
  watchlist: string[]
): Promise<boolean> {
  try {
    const res = await fetch(API_ENDPOINTS.pushSubscribe, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ subscription, watchlist }),
    });
    return res.ok;
  } catch {
    return false;
  }
}

/** 워치 점수 히스토리 조회 (Cycle 92). 실패 시 빈 객체 — 스파크라인 미표시로 graceful */
export async function getWatchScoreHistory(
  codes: string[]
): Promise<Record<string, ScoreHistoryPoint[]>> {
  if (codes.length === 0) return {};
  try {
    const res = await fetch(API_ENDPOINTS.watchScoreHistory(codes));
    if (!res.ok) return {};
    return await res.json();
  } catch {
    return {};
  }
}

export async function submitAnalysis(
  company: string,
  years: number
): Promise<JobSubmitResponse> {
  const res = await fetch(API_ENDPOINTS.analyze, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ company, years }),
  });

  const data = await res.json();

  if (res.status === 300 && data.candidates) {
    const error = new Error(data.message || "여러 종목이 검색되었습니다.") as Error & {
      candidates: ApiError["candidates"];
    };
    error.candidates = data.candidates;
    throw error;
  }

  if (!res.ok && res.status !== 202) {
    throw new Error((data as ApiError).error || "알 수 없는 오류");
  }

  return data as JobSubmitResponse;
}

export async function pollJobStatus(jobId: string): Promise<JobStatusResponse> {
  const res = await fetch(API_ENDPOINTS.jobStatus(jobId));
  if (!res.ok) {
    throw new Error("상태 조회 실패");
  }
  return res.json();
}
